// extracted by mini-css-extract-plugin
module.exports = {"column":"Column_column__26936"};